import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FirebaseService, PlatformService } from '@ld.consumer-portal/utils';

export const maintenanceGuard: CanActivateFn = () => {
  const router = inject(Router);
  const platformService = inject(PlatformService);
  const firebaseService = inject(FirebaseService);

  if (platformService.isNativeMobile()) {
    return true;
  }

  if (firebaseService.isInitialized() && firebaseService.config().maintenance_mode) {
    return router.createUrlTree(['/underMaintenance']);
  }

  return true;
};

export const blockIfNotUnderMaintenance: CanActivateFn = () => {
  const router = inject(Router);
  const platformService = inject(PlatformService);
  const firebaseService = inject(FirebaseService);

  if (platformService.isNativeMobile()) {
    return router.createUrlTree(['/login']);
  }

  if (!firebaseService.isInitialized() || !firebaseService.config().maintenance_mode) {
    return router.createUrlTree(['/login']);
  }

  return true;
};
